import {Transfer, useBundleById, useFullOpenTransfersForTruck} from "../rpc/webrpc-client.gen.ts";
import {Box} from "@mui/joy";
import {useTranslation} from "react-i18next";
import {SuspendedTile, TileSpread} from "../components/Tile.tsx";
import {BundleTile, BundleTileProps} from "../bundle/tile.tsx";
import {useSelf} from "../agent/useSelf.ts";
import {DriverBundleTile, useBundleDestinationCapsule} from "../driver/DriverBundleTile.tsx";

export interface TruckCargoViewProps {
    truckId: string;
}

// function DefaultBundleTile(propsIn: BundleTileProps) {
//     const {
//         bundleId,
//         color: inColor,
//         variant: inVariant,
//         details: inIncludeDetails,
//         ...rest
//     } = propsIn;
//     const props: BundleTileProps = {
//         bundleId,
//         color: inColor ?? "primary",
//         variant: inVariant ?? "outlined",
//         details: inIncludeDetails ?? {"dropoffVenue": true},
//         ...rest,
//     };
//     return <BundleTile key={bundleId} {...props}/>
// }

function TransferBundleTile({transfer, ...rest}: { transfer: Transfer } & Omit<BundleTileProps, "bundleStub">) {
    const {data: self} = useSelf();
    const bundleTqrv = useBundleById({bundleId: transfer.bundle.id});
    const bundle = bundleTqrv.data;
    const destinationCapsule = useBundleDestinationCapsule(bundle);
    if (!bundle) {
        return <SuspendedTile/>;
    }
    if (self?.canDrive) {
        return <DriverBundleTile bundleStub={bundle} {...rest}/>;
    } else {
        return <BundleTile bundleStub={bundle} linkify={true} {...rest}>
            {destinationCapsule}
        </BundleTile>
    }
}

export function TruckCargoView({truckId}: TruckCargoViewProps) {
    const transfersTqrv = useFullOpenTransfersForTruck({truckId});
    const {t} = useTranslation();

    if (!transfersTqrv.isSuccess) {
        return null;
    }

    const transfers = transfersTqrv.data;

    return transfers.length > 0
        ? <TileSpread foods={transfers} estimatedHeight={180}
                      Component={({food}) => {
                          if (food) {
                              return <TransferBundleTile color="success" transfer={food}/>;
                          } else {
                              return <SuspendedTile/>
                          }
                      }}/>
        : <Box>{t("truck.isEmpty")}
        </Box>
}

